(function() {
  const MOBILE_BREAKPOINT = 780;
  const CHART_SELECTOR = '.c-chart';

  function updateChartMessage() {
    document.querySelectorAll(CHART_SELECTOR).forEach(chart => {
      let messageDiv = chart.querySelector('.c-chart__message');

      if (window.innerWidth < MOBILE_BREAKPOINT) {
        if (!messageDiv) {
          messageDiv = document.createElement('div');
          messageDiv.className = 'c-chart__message';

          const messageP = document.createElement('p');
          messageP.className = 'c-chart__content';
          messageP.textContent = "Ce contenu ne peut être affiché en mobile, veuillez vous référer à la transcription textuelle ou passer à une consultation bureau";

          messageDiv.appendChild(messageP);
          chart.appendChild(messageDiv);

          const canvas = chart.querySelector('canvas');
          if (canvas) canvas.style.display = 'none';
        }
      } else {
        if (messageDiv) {
          messageDiv.remove();
          const canvas = chart.querySelector('canvas');
          if (canvas) canvas.style.display = '';
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateChartMessage();
    window.addEventListener('resize', updateChartMessage);
  });
})();
